const catalogRoot = document.querySelector(".t47-catalog");

if (catalogRoot) {
  const form = catalogRoot.querySelector("[data-catalog-form]");
  const results = catalogRoot.querySelector("[data-catalog-results]");
  const meta = catalogRoot.querySelector("[data-catalog-meta]");
  const previousButton = catalogRoot.querySelector("[data-catalog-prev]");
  const nextButton = catalogRoot.querySelector("[data-catalog-next]");
  const categorySelect = catalogRoot.querySelector("[data-catalog-category]");
  const kindSelect = catalogRoot.querySelector("[data-catalog-kind]");
  const yearSelect = catalogRoot.querySelector("[data-catalog-year]");
  const source = catalogRoot.dataset.source;
  const defaultKind = catalogRoot.dataset.defaultKind || "";
  const isDisclosures = catalogRoot.dataset.disclosures === "true";
  const viewBase = catalogRoot.dataset.viewBase || "/records/view/";
  const state = { offset: 0, limit: 25, total: 0 };

  form?.addEventListener("submit", (event) => {
    event.preventDefault();
    state.offset = 0;
    loadCatalog();
  });

  previousButton?.addEventListener("click", () => {
    state.offset = Math.max(0, state.offset - state.limit);
    loadCatalog();
  });

  nextButton?.addEventListener("click", () => {
    if (state.offset + state.limit < state.total) {
      state.offset += state.limit;
      loadCatalog();
    }
  });

  loadCatalog();

  async function loadCatalog() {
    setLoading(true);
    const formData = new FormData(form);
    const params = new URLSearchParams();
    for (const [key, value] of formData.entries()) {
      if (value) params.set(key, value);
    }
    if (defaultKind && !params.get("kind")) {
      params.set("kind", defaultKind);
    }
    params.set("limit", String(state.limit));
    params.set("offset", String(state.offset));

    const endpoint = isDisclosures ? "/api/disclosures" : `/api/catalog/${encodeURIComponent(source)}`;
    try {
      const payload = await fetchJson(`${endpoint}?${params.toString()}`);
      state.total = payload.total || 0;
      renderFacets(payload.facets || {});
      renderResults(payload.records || []);
      renderMeta(payload);
    } catch (error) {
      results.innerHTML = `<div class="usa-alert usa-alert--error"><div class="usa-alert__body"><p class="usa-alert__text">${escapeHtml(error.message)}</p></div></div>`;
      meta.textContent = "";
    } finally {
      setLoading(false);
    }
  }

  function renderFacets(facets) {
    fillFacet(categorySelect, facets.categories, "All categories");
    fillFacet(kindSelect, facets.kinds, "All kinds");
    fillFacet(yearSelect, facets.years, "All years");
  }

  function fillFacet(select, values = [], label) {
    if (!select || select.dataset.touched === "true") return;
    const current = select.value;
    select.innerHTML = `<option value="">${label}</option>`;
    for (const item of values) {
      const option = document.createElement("option");
      option.value = item.name;
      option.textContent = `${item.name} (${item.count})`;
      select.append(option);
    }
    select.value = current;
    select.addEventListener("change", () => {
      select.dataset.touched = "true";
    }, { once: true });
  }

  function renderResults(records) {
    if (!records.length) {
      results.innerHTML = `<p>No records matched this search.</p>`;
      return;
    }

    results.innerHTML = records.map((record) => {
      const recordSource = record.source || source;
      const href = `${viewBase}?source=${encodeURIComponent(recordSource)}&id=${encodeURIComponent(record.id)}`;
      return `
        <article class="t47-record-card">
          <div>
            <p class="t47-record-card__meta">${escapeHtml(record.date || "No date")} · ${escapeHtml(record.category || recordSource)} · ${escapeHtml(record.kind || "record")}</p>
            <h2><a href="${href}">${escapeHtml(record.title || "Untitled record")}</a></h2>
            ${record.summary ? `<p>${escapeHtml(record.summary)}</p>` : ""}
            <p class="t47-record-card__path">${escapeHtml(record.path || "")}</p>
          </div>
          <a class="usa-button" href="${href}">View on T47</a>
        </article>
      `;
    }).join("");
  }

  function renderMeta(payload) {
    const start = payload.total ? payload.offset + 1 : 0;
    const end = Math.min(payload.offset + payload.limit, payload.total);
    meta.textContent = `Showing ${start}-${end} of ${payload.total} records.`;
    previousButton.disabled = payload.offset <= 0;
    nextButton.disabled = payload.offset + payload.limit >= payload.total;
  }

  function setLoading(loading) {
    results.setAttribute("aria-busy", loading ? "true" : "false");
    if (loading) {
      results.innerHTML = `<p>Loading records...</p>`;
    }
  }
}

async function fetchJson(url, options = {}) {
  const response = await fetch(url, options);
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(payload.error || `Request failed with status ${response.status}`);
  }
  return payload;
}

function escapeHtml(value) {
  return String(value || "")
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;");
}
